import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, first, Observable, tap } from 'rxjs';

export interface ApiUsers{
  username: string;
  hashedPassword?: string;
  password?: string;
  accessList: ApiUsersAccessList[]
}

export interface ApiUsersAccessList{
  entity: string;
  read: boolean;
  write: boolean;
  post?: boolean;
  transformer: string;
}

export interface ApiUserResponse{
  success: boolean;
  username: string;
}

@Injectable({
  providedIn: 'root'
})
export class GungSettingsApiUsersService {

  private apiUsersSubject: BehaviorSubject<ApiUsers[]>;

  constructor(protected http: HttpClient) { }

  getApiUsers(nocache = false){
    if (!this.apiUsersSubject || nocache) {
      this.apiUsersSubject = new BehaviorSubject<ApiUsers[]>(null);
      this.updateApiUsersSubject(nocache);
    }

    return this.apiUsersSubject.asObservable();

  }
 

  private getApiUsersServer(nocache): Observable<ApiUsers[]>{
    const url = `json/api/users`;
    const headers = {
      maxAge: nocache ? '-1' : '300'
    };
    return this.http.get<ApiUsers[]>(url, {headers});
  }

  updateApiUsersSubject(nocache){
    if (!this.apiUsersSubject) {
      return;
    }
    this.getApiUsersServer(nocache)
      .pipe(first())
      .subscribe((data: ApiUsers[]) => this.apiUsersSubject.next(data));
  }

  save(user: ApiUsers): Observable<ApiUserResponse>{
    const url = `json/api/users`;
    return this.http.post<ApiUserResponse>(url, user).pipe(tap(_=>{
      this.updateApiUsersSubject(true);
    }));
  }

  removeAfterLastAt(username: string): string {
    const lastAtIndex = username.lastIndexOf("@");
    if (lastAtIndex !== -1) {
        return username.substring(0, lastAtIndex);
    }
    return username; 
  }

  delete(user: ApiUsers): Observable<ApiUserResponse>{
    const url = `json/api/users/${this.removeAfterLastAt(user.username)}`;
    return this.http.delete<ApiUserResponse>(url).pipe(tap(_=>{
      this.updateApiUsersSubject(true);
    }));
  }

}
